import React from "react";

const Footer = () => (
  <div>
    <img src="/assets/images/hdf/rmg-member-logo.png" width="350" alt="rmg-member-logo" />
    <p>
      Raffles Health Insurance Pte Ltd v1.0
      <br />
      (Registration No. 200413569G)
      <br />
      Corporate Office: 585 North Bridge Road #11-00 Raffles Hospital Singapore 188770
      <br />
      Correspondence Address: 25 Tannery Lane Singapore 347786 | Tel: 68126500 Fax: 68126615 |
      Website:{" "}
      <a href="http://www.raffleshealthinsurance.com" target="_blank" rel="noopener noreferrer">
        www.raffleshealthinsurance.com
      </a>
    </p>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/common/Footer.jsx